import { TemplateElement, html, defineElement } from '@webtides/element-js';
import '../../../icon/icon.js';

/**
 * @property {string} label
 * @property {string} description
 * @property {string} src
 * @property {string} assetType
 */
export default class DownloadCard extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            label: '',
            description: '',
            src: '',
            assetType: '',
        };
    }

    template() {
        //TODO button - hover effect?!
        return html`
            <div class="tailwind-container">
                <div class="download-card-container relative py-16 md:px-16">
                    <div class="flex flex-col md:flex-row gap-16 md:justify-between md:items-center">
                        <div class="flex flex-col gap-4">
                            <div class="text-green-medium">${this.label}</div>
                            <div class="text-green-light">${this.description}</div>
                        </div>
                        <slot>
                            <div class="flex flex-row gap-16 items-center">
                                <div
                                    class="text-sm font-medium text-green-medium tracking-[.01em] py-[4px] px-12 rounded-[4px] whitespace-nowrap bg-green-light40"
                                >
                                    ${this.assetType}
                                </div>
                                <a
                                    href="${this.src}"
                                    class="stretched-link"
                                    data-tracking='{"event":"generic","category":"downloads","action":"${this
                                        .assetType}","label":"${this.label}"}'
                                >
                                    <mb-icon name="app--download" class="size-24"></mb-icon>
                                </a>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-download-card', DownloadCard);
